import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m5.657-19.771a1.333 1.333 0 1 0-1.885-1.886L16 14.114l-3.772-3.771a1.333 1.333 0 1 0-1.885 1.886l3.77 3.77-3.77 3.772a1.333 1.333 0 0 0 1.885 1.886L16 17.885l3.77 3.772a1.333 1.333 0 0 0 1.886-1.886L17.888 16z" clipRule="evenodd" /></svg>;
export default SvgIconCrossRoundedFilledSmall;